import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-reasons-to-sell',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './reasons-to-sell.component.html',
  styleUrl: './reasons-to-sell.component.css',
})
export class ReasonsToSellComponent {
  reasonsToSellItems = [
    {
      title: 'card01.title',
      text: 'card01.text',
      imgPath: './assets/sell-with-us/property-value.png',
    },
    {
      title: 'card02.title',
      text: 'card02.text',
      imgPath: './assets/sell-with-us/digital-marketing.png',
    },
    {
      title: 'card03.title',
      text: 'card03.text',
      imgPath: './assets/sell-with-us/guidance.png',
    },
    {
      title: 'card04.title',
      text: 'card04.text',
      imgPath: './assets/sell-with-us/interest.png',
    },
  ];
}
